module.exports = __webpack_public_path__ + "img/glassthicknessminus-174.0b821006.svg";